"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLoggerForSharedIsoUtilsLib = exports.loggerIsoLib = void 0;
const pino_1 = __importDefault(require("pino"));
const is_nodejs_1 = require("../utils/is-nodejs");
let _isoLibRootLogger;
/**
 * Logger for shared-utils-iso, since they cannot use shared-server-utils or shared-browser-utils.
 * Not exported in top index. Do not use directly.
 */
function loggerIsoLib() {
    if (!_isoLibRootLogger) {
        const defaultPinoOpts = {
            level: 'info',
        };
        if (is_nodejs_1.isBrowser()) {
            defaultPinoOpts.browser = {
                asObject: true
            };
        }
        _isoLibRootLogger = pino_1.default(defaultPinoOpts);
    }
    return _isoLibRootLogger;
}
exports.loggerIsoLib = loggerIsoLib;
/**
 * For actual loggers to set root logger used in these shared utils.
 * Called only by shared-server-utils and shared-browser-utils.
 * @param logger
 */
function setLoggerForSharedIsoUtilsLib(logger) {
    _isoLibRootLogger = logger;
}
exports.setLoggerForSharedIsoUtilsLib = setLoggerForSharedIsoUtilsLib;
//# sourceMappingURL=logger-lib-support.js.map